/* ZOQ Leather - Premium product page enhancements.
   Impulse's own product JS still owns variants, price, gallery and cart;
   this only layers UI on top of it. */
(function () {
  function initSelectedLabels(root) {
    root.querySelectorAll('.variant-wrapper[data-type="button"]').forEach(function (wrapper) {
      var label = wrapper.querySelector('.variant__label');
      var fieldset = wrapper.querySelector('fieldset');
      if (!label || !fieldset || label.querySelector('[data-variant-color-label]')) return;

      var span = document.createElement('span');
      span.className = 'zoq-pp-selected';
      label.appendChild(span);

      function update() {
        var checked = fieldset.querySelector('input[type=radio]:checked');
        span.textContent = checked ? ': ' + checked.value : '';
      }
      fieldset.addEventListener('change', update);
      update();
    });
  }

  // Label sizes that are ready made (custom.ready_made ticked on a Standard
  // variant of that size); the list is worked out in Liquid.
  function initRecommended(root) {
    var option = root.getAttribute('data-ready-option');
    var sizes = (root.getAttribute('data-ready-sizes') || '').split('|').filter(Boolean);
    var tag = root.getAttribute('data-ready-label') || 'Popular';
    if (!option || !sizes.length) return;
    root.querySelectorAll('.variant-input[data-index="' + option + '"]').forEach(function (input) {
      if (sizes.indexOf(input.getAttribute('data-value')) !== -1) {
        input.classList.add('zoq-pp-recommended');
        input.setAttribute('data-zoq-tag', tag);
      }
    });
  }

  // The headline overlay belongs to the first slide only; fade it out as
  // soon as the shopper moves to another image.
  function initHeroOverlay(root) {
    var hero = root.querySelector('[data-zoq-hero]');
    if (!hero) return;
    var firstSlide = root.querySelector('[data-product-photos] .product-main-slide');
    if (!firstSlide) return;

    function sync() {
      var slides = root.querySelectorAll('[data-product-photos] .product-main-slide');
      var anySelected = root.querySelector('[data-product-photos] .product-main-slide.is-selected');
      var onFirst = !anySelected || slides[0].classList.contains('is-selected');
      hero.classList.toggle('is-hidden', !onFirst);
    }

    var observer = new MutationObserver(sync);
    root.querySelectorAll('[data-product-photos] .product-main-slide').forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  function initRatingLink(root) {
    var link = root.querySelector('[data-zoq-rating-scroll]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      var target = document.querySelector('.jdgm-review-widget, #judgeme_product_reviews, .jdgm-widget');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Size chart image: read from the config the OnHOW SIZE-CHART section prints
  // on the page, matched by product tag - same rules as the default template.
  function findSizeChart(tags) {
    var scripts = document.querySelectorAll('[id^="onhow-sizechart-config-"]');
    for (var s = 0; s < scripts.length; s++) {
      var config;
      try { config = JSON.parse(scripts[s].textContent); } catch (e) { continue; }
      if (!config || !config.charts) continue;
      for (var c = 0; c < config.charts.length; c++) {
        var chart = config.charts[c];
        if (!chart.tags || !chart.image) continue;
        var chartTags = chart.tags.toLowerCase().split(',').map(function (t) { return t.trim(); });
        for (var t = 0; t < tags.length; t++) {
          if (chartTags.indexOf(tags[t]) !== -1) return chart;
        }
      }
      if (config.fallback && config.fallback.image) return config.fallback;
    }
    return null;
  }

  // Measurement table from the section setting: a header row, then one row per
  // size, columns separated by "|". Cells are numbers or ranges like "37-38".
  function parseSizeTable(text) {
    if (!text) return null;
    var lines = text.split(/\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length < 2) return null;
    var split = function (l) { return l.split('|').map(function (c) { return c.trim(); }); };
    return { header: split(lines[0]), rows: lines.slice(1).map(split) };
  }

  // Upper value of a cell: "37-38" -> 38, "46" -> 46
  function cellMax(cell) {
    var nums = String(cell).match(/[\d.]+/g);
    return nums ? parseFloat(nums[nums.length - 1]) : NaN;
  }

  function toCm(cell) {
    return String(cell).replace(/[\d.]+/g, function (n) { return Math.round(parseFloat(n) * 2.54); });
  }

  // Find My Fit questions; values are inches of ease added to the chest
  var FIT_STEPS = [
    { key: 'build', title: 'Which best describes your build?', options: [
      { label: 'Slim', note: 'Narrow shoulders and chest', value: 0 },
      { label: 'Average', note: 'Balanced proportions', value: 0 },
      { label: 'Athletic', note: 'Broad chest and shoulders', value: 0.5 },
      { label: 'Broad', note: 'Fuller chest or midsection', value: 1 }
    ] },
    { key: 'fit', title: 'How do you like your jackets to fit?', options: [
      { label: 'Fitted', note: 'Close to the body', value: -0.5 },
      { label: 'Regular', note: 'Room to move', value: 0 },
      { label: 'Relaxed', note: 'Loose and easy', value: 1.5 }
    ] },
    { key: 'layer', title: 'What will you usually wear underneath?', options: [
      { label: 'T-shirt', note: 'Light layer', value: 0 },
      { label: 'Shirt or sweater', note: 'Medium layer', value: 1 },
      { label: 'Hoodie or knit', note: 'Heavy layer', value: 2 }
    ] }
  ];

  // Skirts and other bottoms: measured at the waist, so build/layering don't apply
  var FIT_STEPS_BOTTOM = [
    { key: 'fit', title: 'How do you like your skirt to fit?', options: [
      { label: 'Fitted', note: 'Snug at the waist', value: 0 },
      { label: 'Regular', note: 'A little room', value: 0.5 },
      { label: 'Relaxed', note: 'Easy and comfortable', value: 1 }
    ] }
  ];

  function recommendSize(rows, chestIn, answers, ease) {
    var target = chestIn + ease;
    Object.keys(answers).forEach(function (k) { target += answers[k]; });
    for (var i = 0; i < rows.length; i++) {
      if (target <= rows[i].max) {
        var close = rows[i].max - target < 0.5 && rows[i + 1];
        return { size: rows[i].size, alt: close ? rows[i + 1].size : null };
      }
    }
    return { size: null };
  }

  function el(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.firstChild;
  }

  // Size guide drawer (inspired by fjackets.com): "Find my fit" + "Size guide"
  // links beside the Size label open a side drawer with Find My Fit, Size Chart
  // and How to Measure tabs.
  function initSizeGuide(root) {
    var tags = (root.getAttribute('data-product-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var chart = findSizeChart(tags);
    var table = parseSizeTable(root.getAttribute('data-size-table'));
    var tableTitle = root.getAttribute('data-size-title') || 'Size chart';
    var ease = parseFloat(root.getAttribute('data-size-ease')) || 0;
    var note = root.getAttribute('data-fit-note');
    var secondName = (root.getAttribute('data-size-second') || '').toLowerCase();

    // Find My Fit rows: the chosen column, limited to sizes this product sells
    var rows = null;
    var rows2 = null;
    var secondLabel = '';
    var measureName = 'chest';
    if (table) {
      var colName = (root.getAttribute('data-size-column') || '').toLowerCase();
      var col = 1;
      table.header.forEach(function (h, i) { if (i > 0 && h.toLowerCase() === colName) col = i; });
      measureName = table.header[col].toLowerCase();
      var all = table.rows.map(function (r) { return { size: r[0], max: cellMax(r[col]) }; })
        .filter(function (r) { return !isNaN(r.max); });
      var sold = all.filter(function (r) {
        return root.querySelector('.variant-input[data-value="' + r.size + '"]');
      });
      rows = sold.length ? sold : all;
      if (!rows.length) rows = null;

      // Optional second measurement (e.g. Hip for skirts), same sizes as rows
      var col2 = -1;
      table.header.forEach(function (h, i) { if (i > 0 && secondName && h.toLowerCase() === secondName) col2 = i; });
      if (rows && col2 > 0) {
        var byRow = {};
        table.rows.forEach(function (r) { byRow[r[0]] = cellMax(r[col2]); });
        rows2 = rows.map(function (r) { return { size: r.size, max: byRow[r.size] }; })
          .filter(function (r) { return !isNaN(r.max); });
        secondLabel = table.header[col2].toLowerCase();
      }
    }
    var bottom = /waist|hip/.test(measureName);
    var steps = bottom ? FIT_STEPS_BOTTOM : FIT_STEPS;
    if (bottom) {
      var bottomNote = root.getAttribute('data-fit-note-bottom');
      if (bottomNote) note = bottomNote;
    }
    var bespoke = root.getAttribute('data-bespoke-eligible') === 'true';
    if (!chart && !rows) return;

    var sizeWrapper = root.querySelector('.variant-wrapper:has([data-handle="size"])') ||
      root.querySelector('.variant-wrapper[data-type="button"]');
    if (!sizeWrapper) return;
    var label = sizeWrapper.querySelector('.variant__label');
    if (!label) return;

    var ruler = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.5"/><path d="M6.5 8v3M10 8v4M13.5 8v3M17 8v4"/></svg>';
    var links = el('<span class="zoq-pp-sizelinks"></span>');
    if (rows) links.appendChild(el('<button type="button" class="zoq-pp-sizeguide" data-open="fit">' + ruler + 'Find my fit</button>'));
    links.appendChild(el('<button type="button" class="zoq-pp-sizeguide" data-open="chart">' + (rows ? '' : ruler) + 'Size guide</button>'));
    label.classList.add('zoq-pp-label-row');
    label.appendChild(links);

    var tabs = [];
    if (rows) tabs.push(['fit', 'Find My Fit']);
    tabs.push(['chart', 'Size Chart'], ['measure', 'How to Measure']);

    var drawer = el(
      '<div class="zoq-pp-drawer" role="dialog" aria-modal="true" aria-label="Size guide">' +
        '<div class="zoq-pp-drawer__panel">' +
          '<div class="zoq-pp-drawer__head"><strong>Size Guide</strong>' +
            '<button type="button" class="zoq-pp-drawer__close" aria-label="Close">&times;</button></div>' +
          '<div class="zoq-pp-drawer__tabs" role="tablist">' +
            tabs.map(function (t) { return '<button type="button" role="tab" data-tab="' + t[0] + '">' + t[1] + '</button>'; }).join('') +
          '</div>' +
          '<div class="zoq-pp-drawer__body">' +
            (rows ? '<div class="zoq-pp-pane" data-pane="fit"></div>' : '') +
            '<div class="zoq-pp-pane" data-pane="chart"></div>' +
            '<div class="zoq-pp-pane" data-pane="measure">' +
              (bottom ?
                '<ol class="zoq-pp-measure">' +
                  '<li><strong>Waist</strong>Measure around your natural waist, the narrowest part of your torso, keeping the tape level.</li>' +
                  '<li><strong>Hips</strong>Stand with feet together and measure around the fullest part of your hips.</li>' +
                  '<li><strong>Length</strong>Measure from your waist down to where you want the skirt to end.</li>' +
                '</ol>' +
                '<p class="zoq-pp-drawer__tip">Measure over light clothing and keep the tape snug but not tight.</p>'
              :
                '<ol class="zoq-pp-measure">' +
                  '<li><strong>Chest</strong>Measure around the fullest part of your chest, under the arms, keeping the tape level.</li>' +
                  '<li><strong>Shoulders</strong>Measure from the edge of one shoulder to the other, across the top of your back.</li>' +
                  '<li><strong>Sleeve</strong>With your arm relaxed, measure from the shoulder seam down to the wrist bone.</li>' +
                  '<li><strong>Jacket length</strong>Measure from the base of your neck at the back down to where you want the jacket to end.</li>' +
                '</ol>' +
                '<p class="zoq-pp-drawer__tip">Measure over a T-shirt and keep the tape snug but not tight.</p>') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
    document.body.appendChild(drawer);

    var unit = 'in';
    var chartPane = drawer.querySelector('[data-pane="chart"]');
    function renderChart() {
      var html = '';
      if (table) {
        var f = unit === 'cm' ? toCm : function (v) { return v; };
        html += '<div class="zoq-pp-unit"><span>' + tableTitle + '</span><span class="zoq-pp-unit__toggle">' +
          '<button type="button" data-unit="in"' + (unit === 'in' ? ' class="is-active"' : '') + '>IN</button>' +
          '<button type="button" data-unit="cm"' + (unit === 'cm' ? ' class="is-active"' : '') + '>CM</button></span></div>' +
          '<div class="zoq-pp-table-wrap" style="overflow-x:auto"><table class="zoq-pp-table"><thead><tr>' +
          table.header.map(function (h) { return '<th>' + h + '</th>'; }).join('') +
          '</tr></thead><tbody>' +
          table.rows.map(function (r) {
            return '<tr>' + r.map(function (c, i) { return '<td>' + (i === 0 ? c : f(c)) + '</td>'; }).join('') + '</tr>';
          }).join('') +
          '</tbody></table></div>';
      }
      if (note) html += '<p class="zoq-pp-drawer__tip">' + note + '</p>';
      if (chart && !table) {
        html += (rows ? '<p class="zoq-pp-drawer__sub">Full size chart</p>' : '') +
          '<img src="' + chart.image + '" alt="Size chart" loading="lazy">';
        if (chart.description) html += '<div class="zoq-pp-drawer__desc">' + chart.description + '</div>';
      }
      chartPane.innerHTML = html;
      chartPane.querySelectorAll('[data-unit]').forEach(function (b) {
        b.addEventListener('click', function () { unit = b.getAttribute('data-unit'); renderChart(); });
      });
    }

    var fitPane = drawer.querySelector('[data-pane="fit"]');
    var state = { step: 0, chest: '', chest2: '', chestUnit: 'in', answers: {} };
    var extra = rows2 ? 1 : 0;              // extra measurement step (e.g. hip)
    var total = steps.length + 1 + extra;

    function progress(n) {
      return '<p class="zoq-pp-fit__step">Step ' + n + ' of ' + total + '</p>' +
        '<div class="zoq-pp-fit__bar"><span style="width:' + Math.round(n / total * 100) + '%"></span></div>';
    }

    function selectSize(size) {
      var input = root.querySelector('.variant-input[data-value="' + size + '"] input[data-variant-input]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      close();
    }

    function measureStep(n, label, value, optional) {
      return progress(n) + '<h3 class="zoq-pp-fit__q">What is your ' + label + ' measurement?</h3>' +
        '<p class="zoq-pp-drawer__tip">' + (optional ? 'Optional, but it helps us get the fit right. ' : 'Measure your body, not a ' + (bottom ? 'skirt' : 'jacket') + '. ') +
        'Not sure? See <button type="button" class="zoq-pp-link" data-goto="measure">How to Measure</button>.</p>' +
        '<div class="zoq-pp-fit__chest"><input type="number" inputmode="decimal" min="10" max="160" step="0.5" placeholder="e.g. ' + (bottom ? '30' : '40') + '" aria-label="Body measurement" value="' + value + '">' +
        '<span class="zoq-pp-unit__toggle"><button type="button" data-cu="in"' + (state.chestUnit === 'in' ? ' class="is-active"' : '') + '>IN</button>' +
        '<button type="button" data-cu="cm"' + (state.chestUnit === 'cm' ? ' class="is-active"' : '') + '>CM</button></span></div>' +
        '<p class="zoq-pp-fit__error" hidden>Please enter your measurement.</p>' +
        '<button type="button" class="zoq-pp-fit__next">Continue</button>' +
        (optional ? '<button type="button" class="zoq-pp-link" data-skip>Skip this step</button>' : '') +
        (state.step > 0 ? ' <button type="button" class="zoq-pp-link zoq-pp-fit__back">&larr; Back</button>' : '');
    }

    function renderFit() {
      var html;
      var q;
      var qIndex = state.step - 1 - extra;    // index into steps once measurements are done
      if (state.step === 0) {
        html = measureStep(1, measureName, state.chest, false);
      } else if (extra && state.step === 1) {
        html = measureStep(2, secondLabel, state.chest2, true);
      } else if (qIndex < steps.length) {
        q = steps[qIndex];
        html = progress(state.step + 1) + '<h3 class="zoq-pp-fit__q">' + q.title + '</h3><div class="zoq-pp-fit__options">' +
          q.options.map(function (o, i) {
            return '<button type="button" class="zoq-pp-fit__opt" data-opt="' + i + '"><strong>' + o.label + '</strong><span>' + o.note + '</span></button>';
          }).join('') +
          '</div><button type="button" class="zoq-pp-link zoq-pp-fit__back">&larr; Back</button>';
      } else {
        var toIn = function (v) { return state.chestUnit === 'cm' ? parseFloat(v) / 2.54 : parseFloat(v); };
        var rec = recommendSize(rows, toIn(state.chest), state.answers, ease);
        if (rows2 && state.chest2) {
          var rec2 = recommendSize(rows2, toIn(state.chest2), state.answers, ease);
          var idx = function (r) { return r.size === null ? Infinity : rows.map(function (x) { return x.size; }).indexOf(r.size); };
          if (idx(rec2) > idx(rec)) rec = rec2;
        }
        html = resultHtml(rec);
      }
      fitPane.innerHTML = html;
      bindFit();
    }

    function resultHtml(rec) {
      var html;
      if (rec.size) {
        html = '<p class="zoq-pp-fit__step">Your recommended size</p><div class="zoq-pp-fit__result">' + rec.size + '</div>' +
          (rec.alt ? '<p class="zoq-pp-drawer__tip">You are near the top of ' + rec.size + '. For more room, choose ' + rec.alt + '.</p>' : '') +
          '<button type="button" class="zoq-pp-fit__next" data-select="' + rec.size + '">Select size ' + rec.size + '</button>';
      } else {
        html = '<p class="zoq-pp-fit__step">Your recommendation</p><h3 class="zoq-pp-fit__q">Your measurements are above our standard sizes.</h3>';
      }
      if (bespoke) html += '<button type="button" class="zoq-pp-fit__alt" data-bespoke-cta>Or get it made to your measurements</button>';
      html += '<button type="button" class="zoq-pp-link zoq-pp-fit__restart">Start again</button>';
      return html;
    }

    function bindFit() {
      var input = fitPane.querySelector('input[type=number]');
      var field = state.step === 0 ? 'chest' : 'chest2';
      fitPane.querySelectorAll('[data-cu]').forEach(function (b) {
        b.addEventListener('click', function () {
          state[field] = input.value;
          state.chestUnit = b.getAttribute('data-cu');
          renderFit();
        });
      });
      var next = fitPane.querySelector('.zoq-pp-fit__next');
      if (next && input) {
        next.addEventListener('click', function () {
          var v = parseFloat(input.value);
          if (!v || v < 10) {
            fitPane.querySelector('.zoq-pp-fit__error').hidden = false;
            input.focus();
            return;
          }
          state[field] = input.value;
          state.step++;
          renderFit();
        });
      }
      var skip = fitPane.querySelector('[data-skip]');
      if (skip) skip.addEventListener('click', function () { state.chest2 = ''; state.step++; renderFit(); });
      if (next && next.hasAttribute('data-select')) {
        next.addEventListener('click', function () { selectSize(next.getAttribute('data-select')); });
      }
      fitPane.querySelectorAll('[data-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = steps[state.step - 1 - extra];
          state.answers[q.key] = q.options[+b.getAttribute('data-opt')].value;
          state.step++;
          renderFit();
        });
      });
      var back = fitPane.querySelector('.zoq-pp-fit__back');
      if (back) back.addEventListener('click', function () { state.step--; renderFit(); });
      var restart = fitPane.querySelector('.zoq-pp-fit__restart');
      if (restart) restart.addEventListener('click', function () {
        state = { step: 0, chest: '', chest2: '', chestUnit: 'in', answers: {} };
        renderFit();
      });
      var cta = fitPane.querySelector('[data-bespoke-cta]');
      if (cta) cta.addEventListener('click', function () {
        close();
        var bespokeOpen = root.querySelector('[data-bespoke-open]');
        if (bespokeOpen) bespokeOpen.click();
      });
      var gotoMeasure = fitPane.querySelector('[data-goto]');
      if (gotoMeasure) gotoMeasure.addEventListener('click', function () { showTab('measure'); });
    }

    var lastTrigger = null;
    function showTab(name) {
      drawer.querySelectorAll('[data-tab]').forEach(function (t) {
        var on = t.getAttribute('data-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      drawer.querySelectorAll('[data-pane]').forEach(function (p) {
        p.hidden = p.getAttribute('data-pane') !== name;
      });
    }
    function open(name, trigger) {
      lastTrigger = trigger;
      renderChart();
      if (rows) renderFit();
      showTab(name);
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawer.querySelector('.zoq-pp-drawer__close').focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    links.querySelectorAll('[data-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        open(b.getAttribute('data-open'), b);
      });
    });
    drawer.querySelectorAll('[data-tab]').forEach(function (t) {
      t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); });
    });
    drawer.querySelector('.zoq-pp-drawer__close').addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-zoq-pp]').forEach(function (root) {
      initSelectedLabels(root);
      initRecommended(root);
      initHeroOverlay(root);
      initRatingLink(root);
      initSizeGuide(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
